import { Directive } from '@angular/core';

@Directive({
   
  selector: 'webview',
  standalone: false,
})

/** Dummy directive to allow html-tag 'webview' */
export class WebviewDirective { }
